import type { TutorialPageDef } from '../types';

export const adsVideoTutorials: TutorialPageDef[] = [
  {
    key: 'ads-movie',
    label: 'ムービー制作',
    paths: ['/ads/movie'],
    steps: [
      {
        title: 'ムービー制作（β）',
        body: '台本から絵コンテ、クリップ生成、結合まで、複数シーンの動画を段階的に作成できます。',
      },
      {
        target: 'ads-movie-new',
        title: '新規プロジェクト作成',
        body: 'ここから新しいムービープロジェクトを作成できます。',
      },
      {
        target: 'ads-movie-list',
        title: 'プロジェクト一覧',
        body: '作成済みのプロジェクトを確認できます。クリックすると編集画面に進みます。',
      },
    ],
  },
  {
    key: 'ads-movie-editor',
    label: 'ムービー制作（編集）',
    paths: ['/ads/movie/:projectId'],
    steps: [
      {
        target: 'ads-movie-steps',
        title: '制作の4ステップ',
        body: '台本・絵コンテ・クリップ・結合の順にタブで進められます。',
      },
      {
        target: 'ads-movie-back',
        title: '一覧に戻る',
        body: 'このボタンでプロジェクト一覧に戻れます。',
      },
    ],
  },
  {
    key: 'ads-video',
    label: '動画広告',
    paths: ['/ads/video'],
    steps: [
      {
        title: '動画広告',
        body: 'AI動画生成とテンプレート動画の2つの方法で広告動画を作成できます。',
      },
      {
        target: 'ads-video-tabs',
        title: '生成方法を選択',
        body: 'AI動画生成とテンプレート動画をタブで切り替えられます。',
      },
      {
        target: 'ads-video-content',
        title: '動画を作成',
        body: '選んだ方法に応じて入力フォームとプレビューが表示されます。',
      },
    ],
  },
  {
    key: 'ads-music',
    label: '音楽生成',
    paths: ['/ads/music'],
    steps: [
      {
        title: '音楽生成',
        body: '商品情報やテキストから、広告に使えるBGMやジングルを生成します。',
      },
      {
        target: 'ads-music-new',
        title: '音楽を新規作成',
        body: '商品を選ぶかプロンプトを入力して音楽を生成できます。',
      },
      {
        target: 'ads-music-list',
        title: '生成した音楽',
        body: '作成した音楽はカード一覧で確認・再生・ダウンロードできます。',
      },
    ],
  },
  {
    key: 'ads-song',
    label: '歌広告',
    paths: ['/ads/song'],
    steps: [
      {
        title: '歌広告',
        body: '商品情報から歌詞・楽曲・映像を自動生成し、歌広告動画を制作します。',
      },
      {
        target: 'ads-song-new',
        title: '新規プロジェクト作成',
        body: 'タイトルと商品を選ぶだけでプロジェクトを作成できます。',
      },
      {
        target: 'ads-song-list',
        title: '作成済みプロジェクト',
        body: '制作中・完成した歌広告を一覧で確認できます。',
      },
    ],
  },
  {
    key: 'ads-song-editor',
    label: '歌広告（編集）',
    paths: ['/ads/song/:projectId'],
    steps: [
      {
        target: 'ads-song-steps',
        title: '7つの制作ステップ',
        body: '情報登録から歌詞・楽曲・絵コンテ・モーション・プレビュー・書き出しまで進めます。',
      },
      {
        target: 'ads-song-content',
        title: 'ステップの編集画面',
        body: '選んだステップの編集フォームやプレビューがここに表示されます。',
      },
    ],
  },
  {
    key: 'ads-ugc',
    label: 'UGC動画広告',
    paths: ['/ads/ugc'],
    steps: [
      {
        title: 'UGC動画広告',
        body: '口コミ・レビュー風の動画広告をAIで自動生成します（β機能）。',
      },
      {
        target: 'ads-ugc-new',
        title: '新規プロジェクト作成',
        body: '商品や訴求内容を選んでプロジェクトを作成できます。',
      },
      {
        target: 'ads-ugc-list',
        title: '作成済みプロジェクト',
        body: '制作中・完成したUGC動画をカードで確認できます。',
      },
    ],
  },
  {
    key: 'ads-ugc-editor',
    label: 'UGC動画広告（編集）',
    paths: ['/ads/ugc/:projectId'],
    steps: [
      {
        target: 'ads-ugc-steps',
        title: '制作ステップ',
        body: '構成案から映像化・書き出しまでタブで進められます。',
      },
      {
        target: 'ads-ugc-content',
        title: 'ステップの編集画面',
        body: '選んだステップの入力内容やプレビューがここに表示されます。',
      },
    ],
  },
];
